<template>
	<div class="page">
		<div class="searchBox">
			<el-form>
				<el-row>
					<el-col :span="4">
						<el-form-item>
							<el-input style="width:200px;" placeholder="请输入顾客名称或手机号" size="small" v-model="search.keyword" @keyup.enter.native="clickSearch"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="状态" label-width="50px">
							<el-select style="width:140px;" size="small"  class="select" v-model="search.state" placeholder="请选择" @change="clickSearch">
								<!-- -1 全部 0 已删除 1 已预约 2 预约审核通过 3 预约完成 -2 取消预约 -3预约审核失败 -4 预约成功未到 -->
								<el-option
								v-for="item in [{value:-1,label:'全部'},{value:1,label:'已预约'},{value:3,label:'预约完成'},{value:-2,label:'取消预约'}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="5">
						<el-form-item label="预约服务"  label-width="100px">
							<el-cascader
							size="small" 
							style="width:120px;"
							placeholder="请选择"
							v-model="search.server_id"
							@change="clickSearch"
							:options="serviceList"
							>
							</el-cascader>
						</el-form-item>
					</el-col> -->
					<!-- <el-col :span="3">
						<el-form-item label="医生" :label-width="'80px'" >
							<el-select style="width:120px;"  class="select" v-model="search.doctorId" placeholder="请选择" @change="changeDoctor">
								<el-option v-for="item in doctorList" :key="item._id"
								:label="item.basic_info.nick_name" :value="item._id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="美容师" :label-width="'80px'" >
							<el-select style="width:120px;"  class="select" v-model="search.beautyId" placeholder="请选择" @change="changeBeauty">
								<el-option v-for="item in beautyList" :key="item._id"
								:label="item.basic_info.nick_name" :value="item._id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
					<el-col :span="7">
						<el-form-item label="预约日期" :label-width="'80px'" >
							<el-date-picker style="width:240px;" size="small"  @change="changeDatePicker" v-model="datetimerange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="2">
						<resetBtn @reset="reset"></resetBtn>
					</el-col>
					<!-- <el-col :span="1">
						<el-col :span="2" style="float: right;">
							<el-button @click="$router.push({path:'/huiyuan/huiyuanAdd'})" icon="el-icon-plus" type="primary">新建</el-button>
						</el-col>
					</el-col> -->
				</el-row>
			</el-form>
		</div>
		
		<div class="pageConBox">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column label="顾客" width="100">
					<template slot-scope="scope">
						{{scope.row.user_info.user_name}}
					</template>
				</el-table-column>
				<el-table-column label="手机号" width="110">
					<template slot-scope="scope">
						{{scope.row.user_info.user_mobile}}
					</template>
				</el-table-column>
				<el-table-column label="状态" width="100">
					<template slot-scope="scope">
						{{scope.row.states==0?'已删除':''}}
						{{scope.row.states==1?'已预约':''}}
						{{scope.row.states==2?'预约审核通过':''}}
						{{scope.row.states==3?'预约完成':''}}
						{{scope.row.states==-2?'取消预约':''}}
						{{scope.row.states==-3?'预约审核失败':''}}
						{{scope.row.states==-4?'预约成功未到':''}}
					</template>
				</el-table-column>
				<el-table-column label="宠物类型" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.pet_apply_type===1">猫</span>
						<span v-if="scope.row.pet_apply_type===2">犬</span>
						<span v-if="scope.row.pet_apply_type===3">其它</span>
					</template>
				</el-table-column>
				<el-table-column label="预约服务" width="100">
					<template slot-scope="scope">
						{{scope.row.service_info.name}}
					</template>
				</el-table-column>
				<el-table-column label="医生/美容师"  width="100">
					<template slot-scope="scope">
						{{scope.row.service_info.operation_user_name}}
					</template>
				</el-table-column>
				<el-table-column label="预约备注" >
					<template slot-scope="scope">
						{{scope.row.remarks}}
					</template>
				</el-table-column>
				<el-table-column label="取消备注" >
					<template slot-scope="scope">
						{{scope.row.cancle_info&&scope.row.cancle_info.cancle_remark}}
					</template>
				</el-table-column>
				<el-table-column label="预约日期" width="100">
					<template slot-scope="scope">
						{{scope.row.time_info&&scope.row.time_info.date}}
					</template>
				</el-table-column>
				<el-table-column label="预约时间" width="150">
					<template slot-scope="scope">
						{{scope.row.time_info&&scope.row.time_info.time_name}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope">
						<el-button @click="see(scope.row)" type="text" size="small">查看</el-button>
						<!-- <el-button v-if="scope.row.states!==-2" @click="edit(scope.row)" type="text" size="small">编辑</el-button> -->
						<!-- <el-button v-if="scope.row.states==1" @click="clickCheck(scope.row)" type="text" size="small">审核</el-button> -->
						<!-- <el-button v-if="scope.row.states==2" @click="clickArrive(scope.row)" type="text" size="small">到店</el-button> -->
						<el-button v-if="scope.row.states===1" @click="complete(scope.row)" type="text" size="small">完成</el-button>
						<el-button v-if="scope.row.states===1" @click="cancel(scope.row)" type="text" size="small">取消</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="padding:20px 0 0 0;">
				<page :page="page.page" :total="page.total" @change="changePage"></page>
			</div>
		</div>
		<div v-if="dialogEdit_state">
			<dialogEdit :yuyueId="curRow.id" @submit="submit_dialogEdit"></dialogEdit>
		</div>
		<el-dialog title="预约详情" :visible.sync="dialogSee_state" width="800px">
			<el-form >
				<el-row>
					<el-col :span="10" :offset="2">
						<el-form-item label="顾客：" :label-width="formLabelWidth">
							{{curRow.user_info&&curRow.user_info.user_name}}
							<!-- <el-button v-if="curRow.states==3" style="margin-left:20px;" type="success" @click="$router.push({path:'/huifang/huifangList',query:{id:curRow._id,from:'reservation'}});dialogSee_state=false">回访</el-button> -->
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="2">
						<el-form-item label="手机号：" :label-width="formLabelWidth">
							{{curRow.user_info&&curRow.user_info.user_mobile}}
						</el-form-item>
					</el-col>
					
				</el-row>
				<el-row>
					<el-col :span="10" :offset="2">
						<el-form-item label="宠物：" :label-width="formLabelWidth">
							<span v-if="curRow.pet_apply_type===1">猫</span>
							<span v-if="curRow.pet_apply_type===2">犬</span>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="2">
						<el-form-item label="预约服务：" :label-width="formLabelWidth">
							{{curRow.service_info.name}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="2">
						<el-form-item label="预约日期：" :label-width="formLabelWidth">
							{{curRow.time_info&&curRow.time_info.date}}
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="2">
						<el-form-item label="预约时间：" :label-width="formLabelWidth">
							{{curRow.time_info&&curRow.time_info.time_name}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="2">
						<el-form-item label="医生/美容师：" :label-width="formLabelWidth">
							{{curRow.service_info.operation_user_name}}
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="2">
						<el-form-item label="预约状态：" :label-width="formLabelWidth">
							{{curRow.states==0?'已删除':''}}
							{{curRow.states==1?'已预约':''}}
							{{curRow.states==2?'预约审核通过':''}}
							{{curRow.states==3?'预约完成':''}}
							{{curRow.states==-2?'取消预约':''}}
							{{curRow.states==-3?'预约审核失败':''}}
							{{curRow.states==-4?'预约成功未到':''}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="2">
						<el-form-item label="预约备注：" :label-width="formLabelWidth">
							{{curRow.remarks}}
						</el-form-item>
					</el-col>
					
				</el-row>
				<!-- <el-row v-if="curRow.audit_info">
					<el-col :span="5" :offset="2" v-if="curRow.states==-3&&curRow.audit_info">
						<el-form-item label="审核失败原因：" :label-width="formLabelWidth">
							{{curRow.audit_info.audit_remark}}
						</el-form-item>
					</el-col>
					<el-col :span="5" :offset="2">
						<el-form-item label="审核时间：" :label-width="formLabelWidth">
							{{$public.FTime(curRow.audit_info.audit_time)}}
						</el-form-item>
					</el-col>
					<el-col :span="5" :offset="1">
						<el-form-item label="审核人：" :label-width="formLabelWidth">
							{{curRow.audit_info.audit_user_name}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="5" :offset="2">
						<el-form-item label="审核备注：" :label-width="formLabelWidth">
							{{curRow.audit_info&&curRow.audit_info.audit_remark}}
						</el-form-item>
					</el-col>
				</el-row> -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogSee_state=false">确 定</el-button>
			</div>
		</el-dialog>
		<!-- <el-dialog title="预约审核" :visible.sync="dialog_state" width="1000px">
			<el-form >
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="审核结果：" :label-width="formLabelWidth" >
							<el-select style="width:150px;"  class="select" v-model="check" placeholder="请选择">
								<el-option v-for="item in [{value:1,label:'通过'},{value:0,label:'不通过'}]" :key="item.value"
								:label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="备注：" :label-width="formLabelWidth" >
							<el-input type="textarea" v-model="reason" placeholder="请输入备注"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialog_state = false">取 消</el-button>
				<el-button type="primary" @click="submit_check">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="是否到店" :visible.sync="dialog_arrive" width="1000px">
			<el-form >
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="是否到店：" :label-width="formLabelWidth" >
							<el-select style="width:150px;"  class="select" v-model="arrive" placeholder="请选择">
								<el-option v-for="item in [{value:1,label:'顾客已到店'},{value:0,label:'顾客没有到店'}]" :key="item.value"
								:label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialog_arrive = false">取 消</el-button>
				<el-button type="primary" @click="submit_arrive">确 定</el-button>
			</div>
		</el-dialog> -->
	</div>
</template>
<script>
	import page from "../../../components/page.vue"
	import resetBtn from "../../../components/resetBtn.vue"
	import dialogEdit from "./dialogYuyueEdit.vue"
	export default {
		components:{page,resetBtn,dialogEdit},
		data(){
			return{
				tableData:[],
				formLabelWidth: '100px',
				// optionList:[],
				// doctorList:[],
				// beautyList:[],
				// serviceList:[],
				
				search: {
					"keyword": "",
					"state": -1,   // -1 全部 0 已删除 1 已预约 2 预约审核通过 3 预约完成 -2 取消预约 -3预约审核失败 -4 预约成功未到
					// "server_id": [],         // 服务id
					// doctorId:'',
					// beautyId:'',
				},
				datetimerange: [],  // 筛选时间
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				
				// 查看
				dialogSee_state:false,
				curRow:{
					audit_info:{},
					user_info:{},
					pet_info:{},
					service_info:{},
					time_info:{}
				},
				// // 编辑预约
				dialogEdit_state:false,
				// dialog_state:false,
				// check:1,
				// reason:'',
				// // 预约
				// dialog_arrive:false,
				// arrive:1,
				
				
			}
		},
		computed:{
			shopId(){
				return this.$store.state.shopId;
			}
		},
		mounted(){
			this.getTableData();
			// this.getDoctor();
			// this.getBeauty();
			// this.getService();
		},
		methods: {
			// 查看
			see(row){
				this.curRow = row;
				this.dialogSee_state=true;
			},
			// 完成
			complete(row){
				this.$confirm('确定已完成?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(process.env.VUE_APP_AppAdmin+'/api/Reservation/CompleteReservationRecord', {
						id: row.id
					}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			// 取消
			cancel(row){
				this.$prompt('确定要取消?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					// inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
					// inputErrorMessage: '邮箱格式不正确',
					inputPlaceholder:'请输入取消备注'
				}).then(({ value }) => {
					this.$http.post(process.env.VUE_APP_AppAdmin+'/api/Reservation/ReceviedReservationRecord', {
						id: row.id,
						remark: value,
					}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
				
			},
			// 重置筛选
			reset() {
				this.page.page = 1;
				this.search.keyword = '';
				this.search.state = -1;
				// this.search.server_id = [];
				// this.search.doctorId = '';
				// this.search.beautyId = '';
				this.datetimerange = [];
				this.getTableData();
			},
			// 页码改变
			changePage(a) {
				this.page.page = a;
				this.getTableData();
			},
			// 点击查询
			clickSearch() {
				this.page.page = 1;
				this.getTableData();
			},
			// 改变时间
			changeDatePicker(){
				this.page.page=1;
				this.getTableData()
			},
			// // 改变医生
			// changeDoctor(){
			// 	this.search.beautyId = '';
			// 	this.page.page=1;
			// 	this.getTableData()
			// },
			// // 改变美容师
			// changeBeauty(){
			// 	this.search.doctorId = '';
			// 	this.page.page=1;
			// 	this.getTableData()
			// },
			// 获取列表数据
			getTableData(){
				let params = {
					"keyWord": this.search.keyword,
					"sort": "",
					"desc": true, // 是否倒叙
					"user_id": "",
					"shop_id": this.shopId,
					"pet_apply_type": 0, 
					"states": this.search.state, // -1全部 0 已删除 1 已预约 2 预约审核通过 3 预约完成 -2 取消预约 -3预约审核失败 -4 预约成功未到
					"begintime": "",
					"endtime": "",
					// "server_id": this.search.server_id[this.search.server_id.length-1], // 服务id
					"server_id": '', // 服务id
					"pageIndex":this.page.page,
					"pageSize": this.page.pageSize
				}
				if(this.datetimerange&&this.datetimerange.length==2){
					params.begintime=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
					params.endtime=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				}
				// if(this.search.beautyId==''){
				// 	params.operation_user_id = this.search.doctorId;
				// }else{
				// 	params.operation_user_id = this.search.beautyId;
				// }
				this.$http.post(process.env.VUE_APP_AppAdmin+'/api/Reservation/GetReservationList', params).then(res => {
					if (res.code == 0) {
						this.tableData = res.data.list;
						this.page.total = res.data.count;
					}
				})
			},
			
			// 查看
			// edit(row){
			// 	this.curRow = row;
			// 	this.dialogEdit_state=true;
			// },
			// submit_dialogEdit(type){
			// 	this.dialogEdit_state=false;
			// 	if(type==='success'){
			// 		this.getTableData();
			// 	}
			// },
			// // 审核
			// clickCheck(row){
			// 	this.curRow = row;
			// 	this.dialog_state = true;
			// },
			// submit_check(){
			// 	if(this.check==1){
			// 		let params = {
			// 			id:this.curRow._id,
			// 			remark:this.reason
			// 		}
			// 		this.$http.get('/api/Reservation/HandleSuccess', params).then(res => {
			// 			if (res.code == 0) {
			// 				this.$message({
			// 					message: '操作成功',
			// 					type: 'success'
			// 				});
			// 				this.getTableData();
			// 				this.dialog_state = false;
			// 			}
			// 		})
			// 	}else{
			// 		if(this.reason==''){
			// 			this.$message({
			// 				message: '请填写审核失败备注',
			// 				type: 'error'
			// 			});
			// 			return ;
			// 		}
			// 		let params = {
			// 			id:this.curRow._id,
			// 			remark:this.reason
			// 		}
			// 		this.$http.get('/api/Reservation/HandleFail', params).then(res => {
			// 			if (res.code == 0) {
			// 				this.$message({
			// 					message: '操作成功',
			// 					type: 'success'
			// 				});
			// 				this.getTableData()
			// 				this.dialog_state = false;
			// 			}
			// 		})
			// 	}
			// 	this.check = 1;
			// 	this.reason = '';
			// },
			
			// // 到店
			// clickArrive(row){
			// 	this.curRow = row;
			// 	this.dialog_arrive = true;
			// },
			// submit_arrive(){
			// 	console.log(this.arrive)
			// 	if(this.arrive===1){ // 已到店
			// 		let params = {
			// 			id:this.curRow._id,
			// 		}
			// 		this.$http.get('/api/Reservation/Complete', params).then(res => {
			// 			if (res.code == 0) {
			// 				this.$message({
			// 					message: '操作成功',
			// 					type: 'success'
			// 				});
			// 				this.dialog_arrive = false;
			// 				this.getTableData()
							
			// 			}
			// 		})
			// 	}else if(this.arrive===0){  // 未到店
			// 		let params = {
			// 			id:this.curRow._id,
			// 		}
			// 		this.$http.get('/api/Reservation/Notto', params).then(res => {
			// 			if (res.code == 0) {
			// 				this.$message({
			// 					message: '操作成功',
			// 					type: 'success'
			// 				});
			// 				this.getTableData()
			// 				this.dialog_arrive = false;
			// 			}
			// 		})
			// 	}
			// 	this.arrive = 1;
			// },
			// 获取医生
			// getDoctor(){
			// 	let params = {
			// 		keyword:'',
			// 		pageIndex:1,
			// 		pageSize:100,
			// 	}
			// 	this.$http.get('/api/Staff/DoctorList', params).then(res => {
			// 		if (res.code == 0) {
			// 			this.doctorList = res.data.data;
			// 		}
			// 	})
			// },
			// 获取美容师
			// getBeauty(){
			// 	let params = {
			// 		keyword:'',
			// 		pageIndex:1,
			// 		pageSize:100,
			// 	}
			// 	this.$http.get('/api/Staff/BeautyList', params).then(res => {
			// 		if (res.code == 0) {
			// 			this.beautyList = res.data.data;
			// 		}
			// 	})
			// },
			// 获取预约服务
			// getService(){
			// 	this.$http.get('/api/Reservation/ShopService').then(res => {
			// 		if (res.code == 0) {
			// 			this.serviceList = res.data;
			// 			let list = [];
			// 			for(let i=0;i<this.serviceList.services_list.length;i++){
			// 				let obj = this.serviceList.services_list[i];
			// 				obj.label=obj.name;
			// 				obj.value=obj._id;
			// 				if(this.serviceList.services_list[i].services_list!=null){
			// 					obj.children = [];
			// 					for(let a=0;a<this.serviceList.services_list[i].services_list.length;a++){
			// 						let obj1 = this.serviceList.services_list[i].services_list[a];
			// 						obj1.label=obj1.name;
			// 						obj1.value=obj1._id;
			// 						obj.children.push(obj1)
			// 					}
			// 				}
			// 				list.push(obj)
			// 			}
			// 			this.serviceList = list;
			// 		}
			// 	})
			// },
		}
	}
</script>
<style scoped lang="scss">
.page{
	.searchBox{
		.el-form-item{
			margin-bottom:0;
		}
	}
	.pageConBox{
		padding:0 20px;
		min-height: 600px;
		margin-top:10px;
	}
}
</style>
